<script>
	export let txt;
</script>

<p>
	{txt}
</p>
